import React, { useState } from 'react';

import AttachDocuments from '@components/common/AttachDocuments';

import { useMutateAttachFiles } from '@hooks/common/useMutateAttachFiles';

import { IAssetFile } from '@interfaces/assets/asset';

import {
	acceptedFileTypes,
	fileErrors,
	MAX_BYTES,
	supportsText,
} from './constants';

interface IAttachAssetDocumentsProps {
	toggleUploadFilesModal: () => void;
	handleUploadFiles: (uploadedFiles: Array<IAssetFile>) => void;
}

const AttachAssetDocuments = ({
	toggleUploadFilesModal,
	handleUploadFiles,
}: IAttachAssetDocumentsProps) => {
	const [uploadedFiles, setUploadedFiles] = useState<Array<IAssetFile>>([]);

	const {
		createUploadUrlAttachment,
		progress,
	} = useMutateAttachFiles({ setUploadedFiles });

	const clearUploadedFiles = () => setUploadedFiles([]);

	const onUploadClickHandler = () => {
		handleUploadFiles(uploadedFiles);
		toggleUploadFilesModal();
	};

	return (
		<AttachDocuments
			acceptedFileTypes={acceptedFileTypes}
			createUploadUrlAttachment={createUploadUrlAttachment as any}
			fileErrors={fileErrors}
			fileRejectionErrorHandler={clearUploadedFiles}
			maxBytes={MAX_BYTES}
			onDropAcceptedHandler={clearUploadedFiles}
			onUploadClickHandler={onUploadClickHandler}
			progress={progress}
			supportsText={supportsText}
			toggleUploadFilesModal={toggleUploadFilesModal}
			uploadedFilesLength={uploadedFiles.length}
		/>
	);
};

export default AttachAssetDocuments;
